import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ScreeningResultsService } from '../../services/screening-results/screening-results.service';

/**
 * The four headline numbers for the brief.
 *
 * Everything here is summed from real per-creator results, so the strip stays blank-ish rather
 * than confidently wrong while the cohort is still loading.
 */
@Component({
  selector: 'scr-screen-kpis',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './screen-kpis.html',
})
export class ScreenKpis {

  readonly results = inject(ScreeningResultsService);

  readonly loading = computed(() => this.results.cohortState() === 'loading');

  readonly flagSuffix = computed(() => {
    const open = this.results.kpis().openFlags;
    return open > 0 ? `${open} need review` : undefined;
  });
}
